import { useQueryClient } from "@tanstack/react-query";

import {
  JobQueryParams,
  JobTrackerResponse,
  JobUpdate,
} from "@/types";

export const useAddJobDifficultyUrgency = () => {
  const queryClient = useQueryClient();

  return ({
    companyId,
    jobId,
    jobQueryParams,
    newJobDifficultyUrgency,
  }: {
    companyId: string;
    jobId: string;
    jobQueryParams?: JobQueryParams;
    newJobDifficultyUrgency: JobUpdate;
  }) => {
    if (jobQueryParams) {
      queryClient.setQueryData(
        ["jobs", jobQueryParams],
        (cachedJobs: JobTrackerResponse[] | undefined) => {
          if (!cachedJobs) return cachedJobs;
          return cachedJobs.map((job) => {
            if (job.jobId === jobId) {
              return {
                ...job,
                jobUpdates: [
                  newJobDifficultyUrgency,
                  ...job.jobUpdates,
                ],
              };
            }
            return job;
          });
        },
      );
    }

    queryClient.setQueryData<JobUpdate[]>(
      ["job-difficulty-urgencies", companyId, jobId],
      (old) => [newJobDifficultyUrgency, ...(old ?? [])],
    );
  };
};
